/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */

import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography
} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { useState } from 'react'

import { getTranslate } from '../../localization'
import { CheckBoxDataType } from '../../types/customCheckBox'
import { ChangeModal } from '../ChangeModal'
import useStyles from './styles/index.styles'

type Props = {
  header: string
  options: CheckBoxDataType[]
  selectedItems: string[]
  setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  includesWarning?: boolean
  includesAll?: boolean
}

const CustomCheckBox = ({
  header,
  options,
  selectedItems,
  setSelectedItems,
  includesWarning,
  includesAll
}: Props) => {
  const classes = useStyles()
  const visibleOption = 4
  const [showOptionCount, setshowOptionCount] = useState<number>(visibleOption)
  const [expanded, setexpanded] = useState<boolean>(false)
  const show = options.length > visibleOption
  const [showModal, setShowModal] = useState(false)
  const [pendingOption, setPendingOption] = useState<CheckBoxDataType | null>(
    null
  )
  const handleShowMoreClicked = () => {
    if (expanded) {
      setshowOptionCount(visibleOption)
    } else {
      setshowOptionCount(options.length)
    }
    setexpanded(!expanded)
  }

  const handleCheckboxChange = (value: string, includesWarning: boolean) => {
    if (includesWarning) {
      const isCurrentlySelected = selectedItems.includes(value)
      if (isCurrentlySelected) {
        setPendingOption(options.find((d) => d.value === value) || null)
        setShowModal(true)
        return
      }
    }

    if (value === 'All') {
      if (selectedItems.length === options.length) {
        setSelectedItems([])
      } else {
        setSelectedItems(options.map((d) => d.value))
      }
    } else {
      setSelectedItems((prev) => {
        const updated = prev.includes(value)
          ? prev.filter((v) => v !== value)
          : [...prev, value]

        return updated
      })
    }
  }

  return (
    <>
      <div className={classes.root}>
        <Typography variant="h5" className={classes.filterText}>
          {getTranslate(header)}
        </Typography>
        {/* <Collapse in={selectedItems.length == 0 && includesWarning}>
          <div className={classes.warning}>
            <Typography variant="subtitle1" className={classes.verticalAlign}>
              <WarningIcon className={classes.icon} />
              {getTranslate('Warning')}
            </Typography>
            <Typography variant="h5" className={classes.text}>
              {getTranslate(
                'You have to choose one Provider to continue reservation'
              )}
            </Typography>
          </div>
        </Collapse> */}
        <FormGroup className={classes.form}>
          {includesAll && options.length > 1 && (
            <div className={classes.Row}>
              <Typography variant="h6" className={classes.title}>
                {getTranslate('All')}
              </Typography>
              <FormControlLabel
                classes={{ root: classes.check }}
                label=""
                control={
                  <Checkbox
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    checked={selectedItems.length === options.length}
                    onChange={() =>
                      handleCheckboxChange(
                        'All',
                        includesWarning ? includesWarning : false
                      )
                    }
                  />
                }
              />
            </div>
          )}
          {options.slice(0, showOptionCount).map((d, index) => (
            <div className={classes.Row} key={index}>
              <Typography variant="h6" className={classes.title}>
                {d.title}
              </Typography>
              <FormControlLabel
                classes={{ root: classes.check }}
                label=""
                control={
                  <Checkbox
                    color="primary"
                    size="small"
                    className={classes.checkbox}
                    checked={selectedItems.includes(d.value)}
                    onChange={() =>
                      handleCheckboxChange(
                        d.value,
                        includesWarning ? includesWarning : false
                      )
                    }
                  />
                }
              />
            </div>
          ))}
        </FormGroup>
        {show && (
          <div className={classes.btn}>
            <Button
              className={classes.showMoreBtn}
              variant="text"
              endIcon={
                <KeyboardArrowDownIcon
                  className={expanded ? classes.showLessBtn : ''}
                />
              }
              onClick={handleShowMoreClicked}>
              <Typography variant="h6" className={classes.greyText}>
                {expanded
                  ? getTranslate('Show Less')
                  : getTranslate('Show More')}
              </Typography>
            </Button>
          </div>
        )}
      </div>
      <ChangeModal
        title="Your Providers List Is Being Changed"
        isOpen={showModal}
        onClick={() => {
          if (pendingOption) {
            handleCheckboxChange(pendingOption.value, false)
            setPendingOption(null)
          }
          setShowModal(false)
        }}
        onClose={() => {
          setPendingOption(null)
          setShowModal(false)
        }}
      />
    </>
  )
}

export default CustomCheckBox
